import { Button, Col, DropdownMenu, DropdownToggle, Nav, NavItem, Row, UncontrolledButtonDropdown } from "reactstrap";
import { IoIosMore } from "react-icons/io";
import LinkService from "../../services/link";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ContentSteeringController } from "hls.js";

const Link = ({ id, linkType }) => {
	const [hasCreatedLink, setHasCreatedLink] = useState(false);

	const [linkName, setLinkName] = useState()
	const [randomString, setRandomString] = useState()
	const [msg, setMsg] = useState()

	const userId = useSelector((state) => state.auth.userId)
	const location = useLocation()

	const getRandomString = (length = 5) => {
		const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
		return [...Array(length)].map(() => characters[Math.floor(Math.random() * characters.length)]).join('')
	}
	//const randomString = getRandomString();
	const rootDomain = window.location.hostname === 'localhost' ? 'localhost:3000' : window.location.hostname
	//const linkName = `${rootDomain}/${linkType}/` + randomString

	useEffect(() => {
		if (!linkName && !randomString) {
			const string = getRandomString();
			const name = `${rootDomain}/${linkType}/` + string
			//console.log('Setting linkname', name)
			setRandomString(string)
			setLinkName(name)
		}
	}, [linkName, randomString])

	const right = ['video', 'formlink', 'pdf'].includes(linkType) ? -15 : null
	const bottom = ['video', 'formlink', 'pdf'].includes(linkType) ? 3 : null

	let linkText = 'Text'
	if (linkType === 'video') {
		linkText = 'Klicka på knappen nedan för att skapa en länk till videon och kopiera den till urklipp. \
					Obs: Skapa bara en länk! Länken är giltig så länge du har ett aktiverat konto hos oss.'
	} else if (linkType === 'lesson') {
		linkText = 'Klicka på knappen nedan för att skapa en länk till lektionen och kopiera den till urklipp. \
					Obs: Skapa bara en länk! Länken är giltig så länge du har ett aktiverat konto hos oss.'
	} else if (linkType === 'pdf') {
		linkText = 'Klicka på knappen nedan för att skapa en länk till dokumentet och kopiera den till urklipp. \
					Obs: Skapa bara en länk! Länken är giltig så länge du har ett aktiverat konto hos oss.'
	} else if (linkType === 'formlink') {
		linkText = 'Klicka på knappen nedan för att skapa en länk till formuläret och kopiera den till urklipp. \
					Obs: Skapa bara en länk! Länken är giltig så länge du har ett aktiverat konto hos oss.'
	}



	return (
		<UncontrolledButtonDropdown style={{ position: 'absolute', right: right, bottom: bottom }} container="body">
			<DropdownToggle className={'btn-icon btn-icon-only mb-2 mr-0 la-more-dropdown'}>
				<div className="btn-icon-wrapper">
					<IoIosMore className="rotate-90" />
				</div>
			</DropdownToggle>
			<DropdownMenu left='left' positionFixed className="dropdown-menu-lg" >
				<Nav vertical>
					<NavItem className="nav-item-header">
						Skapa länk
					</NavItem>
					<NavItem className="ml-3 mr-3 la-more-dropdown-body" >
						<p className='la-linktext'>{msg ? msg : linkText}</p>
						<p className='la-linktext'>{linkName}</p>
					</NavItem>
					{!msg &&
						<Row>
							<Col>
								<NavItem className="nav-item-btn text-right">
									<Button size="sm" className="" color="success"
										onClick={async () => {
											try {
												const today = new Date()
												const exp = new Date(today.setHours(today.getHours() + 48))
												const data = {
													linkRefNumber: randomString,
													user: userId !== 'skolon_anonymous_teacher' ? userId : null,
													path: location.pathname,
													lesson: linkType === 'lesson' ? id : null,
													//assignment: linkType === 'video' ? id : null,
													// We can save all types of assignments as video
													assignment: ['video', 'pdf', 'formlink'].includes(linkType) ? id : null,
													expiryDate: exp
												}
												await LinkService.addLink(data, linkType)
												setHasCreatedLink(true)

												console.log('Skapade länk', linkName)

												try {
													await navigator.clipboard.writeText(linkName)
													//alert('Länken ' + linkName + ' är skapad och kopierad.')
													setMsg('Länken är skapad och kopierad.')

												} catch (e) {
													console.error('Link created, but error copying link', e)
													// alert('Länken kunde inte kopieras.')
													setMsg('Länken är skapad, men kunde inte kopieras. Kopiera länken manuellt.')
												}

											} catch (e) {
												console.error('Error creating link', e)
												//alert('Länken kunde inte skapas.')
												setMsg('Länken kunde inte skapas.')
											}
										}}
										disabled={hasCreatedLink}
									>
										Skapa och kopiera
									</Button>
								</NavItem>
							</Col>
						</Row>
					}
				</Nav>
			</DropdownMenu>
		</UncontrolledButtonDropdown>
	)
}

export default Link
